import Select from './Select.component';

export default Select;